module.exports = __webpack_public_path__ + "static/media/galerija_2017 (35).c5d462b6.jpg";